'use client';

import { Elements } from '@stripe/react-stripe-js';
import { StripeElementLocale, loadStripe } from '@stripe/stripe-js';
import { useLocale } from 'next-intl';
import { FC, PropsWithChildren } from 'react';

const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY!);

const StripeProvider: FC<PropsWithChildren> = (props) => {
  const locale = useLocale();
  return (
    <Elements
      stripe={stripePromise}
      options={{
        locale: locale as StripeElementLocale,
      }}
    >
      {props.children}
    </Elements>
  );
};

export default StripeProvider;
